import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';
import { TagCondition, createTagCondition } from '../TagCondition';
import { ParamCondition, createParamCondition } from '../ParamCondition';
import { LocalizedValue, createLocalizedValue } from '../../../LocalizedValue';

export type WorkoutPhaseTemplate = {
  id: string;
  scriptId?: string;
  description: LocalizedValue[];
  tagConditions: TagCondition[];
  params: ParamCondition[];
  toJS(replaceId?: boolean): any;
  copy(): WorkoutPhaseTemplate;
  setParam(paramName: string, value?: any): void;
  removeParam(paramName: string): void;
};

export function createWorkoutPhaseTemplate(json?: any): WorkoutPhaseTemplate {
  const template: WorkoutPhaseTemplate = makeAutoObservable({
    id: json?.id || UUID(),
    scriptId: json?.scriptId,
    tagConditions: (json?.tagConditions || []).map((t: any) => createTagCondition(t)),
    params: (json?.params ?? []).map((p: any) => createParamCondition(p)),
    description: (json?.description ?? []).map((d: any) => createLocalizedValue(d)),

    toJS(replaceId?: boolean) {
      return {
        id: replaceId ? UUID() : this.id,
        scriptId: this.scriptId,
        description: this.description.map((d) => d),
        tagConditions: this.tagConditions.map((t) => t),
        params: this.params.map((p) => p),
      };
    },

    copy(): WorkoutPhaseTemplate {
      return createWorkoutPhaseTemplate(this.toJS(true));
    },

    setParam(paramName: string, value?: any) {
      (this.params as any)[paramName] = value;
    },

    removeParam(paramName: string) {
      delete (this.params as any)[paramName];
    },
  });

  return template;
}
